import * as React from "react"
import { cn } from "@/lib/utils"

export interface TooltipProps {
  content: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function Tooltip({ content, children, className }: TooltipProps) {
  return (
    <span className={cn("relative inline-block group", className)}>
      {children}
      <span className="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2 z-50 w-[260px] whitespace-normal break-words rounded bg-foreground px-2 py-1 text-[10px] text-background opacity-0 shadow transition-opacity group-hover:opacity-100">
        {content}
      </span>
    </span>
  )
}
